import { render, staticRenderFns } from "./page.vue?vue&type=template&id=250508f4&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=250508f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250508f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\项目\\toogleTable\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250508f4')) {
      api.createRecord('250508f4', component.options)
    } else {
      api.reload('250508f4', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=250508f4&scoped=true&", function () {
      api.rerender('250508f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "kingdee/hr/toogleTable/components/page.vue"
export default component.exports